export default class DisqualifyingConditionsAgreement {
	public version: number | null = null;
	public riskMeetsEligibilityRequirements: boolean | null = null;

	public constructor() {

	}
};